import React, { useEffect,useState } from 'react';
import {  Link,useNavigate } from 'react-router-dom';
import Select from '../select';
import Input from '../input';
import Button from '../button';
import CheckBox from '../checkbox';

import MessageDialog from '../messageDialog';
import LoadingOverlay from '../loadingOverlay';
import ConfirmDialog from '../confirmDialog';
import {get, post } from '../../request'
import './styles.scss';

function ViewInvoiceDialog({ initItem, list, invoiceTotalPrice, onConfirm, onCancel,  isShow ,title ,isView}) {
    const [isLoading, setIsLoading] = useState(false);
    const [invoiceItem, setInputs] = useState(initItem || { invoiceType :0});

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isShowList, setIsShowList] = useState(false);
    useEffect(() => {
        if (initItem != invoiceItem) {
            setInputs(initItem || { invoiceType: 0 });
        }
        loadData();
    }, [ initItem]);

    const loadData = () => {
    }
   

    const showDialog = () => {
        //setIsVisible(true);
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };

    const handleClick = () => {
        //onConfirm();
        setSuccessMessage("");
        setErrorMessage("");
        setIsLoading(true);

        if (invoiceItem.businessAskInvoiceProductEntityList) {
            for (var i = 0; i < invoiceItem.businessAskInvoiceProductEntityList.length; i++) {
                invoiceItem.businessAskInvoiceProductEntityList[i].id = 0;
                invoiceItem.businessAskInvoiceProductEntityList[i].quantity = invoiceItem.businessAskInvoiceProductEntityList[i].outInNum;
                invoiceItem.businessAskInvoiceProductEntityList[i].totalPrice = invoiceItem.businessAskInvoiceProductEntityList[i].outInNum * invoiceItem.businessAskInvoiceProductEntityList[i].unitPrice;
                invoiceItem.businessAskInvoiceProductEntityList[i].erpReceiveRecordInvoiceCertificateId = invoiceItem.businessAskInvoiceProductEntityList[i].askInvoiceId
            }
        }
        invoiceItem.address.province = invoiceItem.address.province.id;
        invoiceItem.address.city = invoiceItem.address.city.id;
        invoiceItem.address.district = invoiceItem.address.district.id;
        invoiceItem.invoiceMoney = invoiceItem.totalPrice;
        invoiceItem.certificatedAmount = invoiceItem.totalPrice;
       
        post('delianapi/businessaskinvoice/save', invoiceItem ).then((response)=> {
            setIsLoading(false);
            if (response.statusCode !== 200) {
                setErrorMessage( response.message);
                return;
            }
            var item = response.items[0];
            if (onConfirm) {
                onConfirm(item);
            }
            hideDialog();

        });
       
    };

    const handleCancel = () => {
        
        hideDialog();
    };
    const handCheckChange = (invoiceType, value) => {
        var newInvoiceType;
        if (value) {
            newInvoiceType = invoiceType;
        }
        else {
            newInvoiceType = invoiceType === 0 ? 1 : 0;
        }
        setInputs({ ...invoiceItem, invoiceType: newInvoiceType});
    }
    const handMoreClick = () => {
        setIsShowList(true);
    }
    const handBackClick = () => {
        setIsShowList(false);
    }
    const handChooseClick = (address) => {
        setInputs({
            ...invoiceItem,
            postAddress: address.address,
            postPhone: address.mobilePhone,
            postMan: address.contactName,
            address: address
        });
        setIsShowList(false);
    }
    return (
        <div className="dialog invoice" style={{ display: isShow ? 'flex' : 'none' }}>
           <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                {
                    !isShowList && <div className="dialogTitle">{title}</div>
                }               
                {
                    !isView && !isShowList &&
                    <div className="content-div">
                        申请金额：
                        <span className="red" >
                            <small className="fs-14" >￥</small>
                            <span className="fs-24" >{parseFloat(invoiceTotalPrice || 0).toFixed(2)}</span>
                        </span>
                    </div>
                }
                {
                    !isShowList &&
                    <div className="dialog-content">
                        <div className="check-div">
                            <CheckBox value={invoiceItem.invoiceType == 0 || false} name="invoiceType0"
                                onChange={(value) => handCheckChange(0, value)} title="增值税专用发票"
                            />
                            <CheckBox value={invoiceItem.invoiceType == 1 || false} name="invoiceType1"
                                onChange={(value) => handCheckChange(1, value)} title="增值税普通发票"
                            />
                        </div>
                        <div className="dialog-in">发票信息</div>
                        {
                            invoiceItem.invoiceType == 0 &&
                            <div className="content-div">
                                <div className="content-title">发票抬头：</div>
                                <div className="content-info">{invoiceItem.invoiceTitle}</div>
                                <div className="content-title">纳税人识别号：</div>
                                <div className="content-info">{invoiceItem.taxpayerCode}</div>

                                <div className="content-title">注册地址：</div>
                                <div className="content-info">{invoiceItem.taxpayerAddress}</div>

                                <div className="content-title">注册电话：</div>
                                <div className="content-info">{invoiceItem.taxpayerPhone}</div>

                                <div className="content-title">开户银行：</div>
                                <div className="content-info">{invoiceItem.bankName}</div>
                                <div className="content-title">开户账号：</div>
                                <div className="content-info">{invoiceItem.bankAccount}</div>

                            </div>
                        }
                        {
                            invoiceItem.invoiceType == 1 &&
                            <div className="content-div">
                                <div className="content-title">发票抬头：</div>
                                <div className="content-info">{invoiceItem.invoiceTitle}</div>
                            </div>
                        }
                        <div className="dialog-in">邮寄地址
                            <div className="morebtn" onClick={handMoreClick}>更多地址信息</div>
                        </div>
                        <div className="content-div" >
                            <div className="content-info1">{invoiceItem.postMan + '  ' + invoiceItem.postPhone}</div>
                            <div className="content-info1">{invoiceItem.postAddress}</div>
                        </div>
                        <div className="btn-div">
                            <Button btnclass={`login_btn `} onClick={() => handleClick()}
                                title="确认申请" />
                        </div>

                    </div>
                }
                {
                    isShowList &&
                    <div className="addressList">
                        <div className="dialogTitle">
                            <div className="back" onClick={handBackClick}></div>
                            地址信息
                        </div>
                        <div className="contactList">
                            {
                                list.map((item, index) => (
                                    <div className="contactItem address" key={item.id} onClick={() => handChooseClick(item)} >
                                        <div className="contactName">
                                            {item.contactName + ' ' + item.mobilePhone}                                           

                                        </div>
                                        <div className="contactDetail"> {
                                            (item.provinceName || '') + ' ' + (item.cityName || '')
                                            + ' ' + (item.districtName || '') + ' ' + item.address + ' '
                                            + item.zipCode
                                        }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>

            <MessageDialog message={successMessage || errorMessage} onCancel={() => {
                setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading} />
           
        </div>
    );
};

export default ViewInvoiceDialog;